package com.appsyde.shared.network

import io.ktor.client.plugins.api.createClientPlugin
import io.ktor.client.request.header

/**
 * Configuration for [BearerTokenPlugin].
 * [tokenProvider] is invoked at request time so the current token is always used
 * (e.g. after it was restored from cookie via GET /auth/session-token).
 */
class BearerTokenPluginConfig {
    var tokenProvider: (() -> String?)? = null
}

/**
 * Client plugin that adds `Authorization: Bearer <token>` to each request by calling
 * [BearerTokenPluginConfig.tokenProvider] at request time. Install with a provider that
 * reads the token from storage (e.g. platform localStorage) so that requests sent
 * after the token is set (e.g. after session-token exchange) include it.
 */
val BearerTokenPlugin = createClientPlugin("BearerToken", ::BearerTokenPluginConfig) {
    val tokenProvider = pluginConfig.tokenProvider
    onRequest { request, _ ->
        tokenProvider?.invoke()?.takeIf { it.isNotBlank() }?.let { token ->
            request.header("Authorization", "Bearer $token")
        }
    }
}
